import * as i0 from "@angular/core";
var LanguageDataService = /** @class */ (function () {
    function LanguageDataService() {
    }
    LanguageDataService.prototype.getLanguages = function () {
        // Use hardcoded data for now.
        return Promise.resolve(LANGUAGES.slice());
    };
    LanguageDataService.ngInjectableDef = i0.defineInjectable({ factory: function LanguageDataService_Factory() { return new LanguageDataService(); }, token: LanguageDataService, providedIn: "root" });
    return LanguageDataService;
}());
export { LanguageDataService };
var LANGUAGES = [
    { code: "de", name: "Deutsch" },
    { code: "fr", name: "Français" },
    { code: "it", name: "Italiano" },
    { code: "en", name: "English" },
];
